import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import { Box } from '@mui/material';

const customIconMapper = {
	'inActive-grey': { icon: HorizontalRuleIcon, props: { sx: { color: 'grey', fontSize: '1.8rem' } } }
};

export const ProcessMonitoringStatus = ({ CriticalParameterIcon, align = 'left', ml = 6, sx, width, customIcon }) => {
	if (![true, false].includes(CriticalParameterIcon)) {
		return
	}
	const style =
	{
		fontSize: "1.7rem",
		...sx
	}
	const { icon: CustomIconComponent, props } = customIconMapper[customIcon] || {};
	return (
		<Box textAlign={align} ml={ml} width={width}>
			{CustomIconComponent ? (
				<CustomIconComponent {...props}/>
			) : CriticalParameterIcon ? (
				<CheckIcon sx={style} color={"success"} />
			) : (
				<CloseIcon sx={style} color={"error"} />
			)}
		</Box>
	);
}